<script setup>
import FaqCard from '@components/global/faq-card.vue'
import { useGlobalStore } from '@stores/global'
const global = useGlobalStore()

</script>
<template>
  <section class="container flex flex-col gap-8 md:flex-row">
    <h2 class="flex-1 font-heading text-h3 font-medium uppercase text-sf-purple-base md:text-h2">faq</h2>
    <div class="flex w-full flex-col gap-4 md:w-half">
      <FaqCard v-for="faq in global.faqs" :key="faq.question" class="first:pt-0 last:pb-0" :faq="faq" />
    </div>
  </section>
</template>
<style scoped></style>
